
import { createActionTypeModel } from "../../../../store/global/action-model";
// Type Container for AccountsRoyalty Action/Mutation Types. Use it in   accounts/actions.js, accounts/mutations.js and the Vuex Host Component 
export const AccountDistributionData = createActionTypeModel('AccountDistributionData');
export const AccountList = createActionTypeModel('AccountList');
export const DistributionAccountDetails = createActionTypeModel('DistributionAccountDetails');
export const DistributionAccountRelatedContacts = createActionTypeModel('DistributionAccountRelatedContacts');
export const DistributionAccountRelatedFile = createActionTypeModel('DistributionAccountRelatedFile');

export const DistributionAccountInvoiceContact = createActionTypeModel('DistributionAccountInvoiceContact');
export const DistributionAccountDeliveryAddress = createActionTypeModel('DistributionAccountDeliveryAddress');

export const DistributionOrderList = createActionTypeModel("DistributionOrderList");
export const DistributionAccountBackOrder = createActionTypeModel("DistributionAccountBackOrder");
export const DistributionCatalogueLabels = createActionTypeModel("DistributionCatalogueLabels");
export const DistributionCatalogueAccount = createActionTypeModel("DistributionCatalogueAccount");
export const AccountDetailsItems = createActionTypeModel("AccountDetailsItems");
export const ACCOUNT_FILES = createActionTypeModel('ARTIST_FILES');
export const AccountData = createActionTypeModel('AccountData');

export const DistributionAccountCurrentStatements = createActionTypeModel("DistributionAccountCurrentStatements");


export const DistributionAccountImportSetup = createActionTypeModel("DistributionAccountImportSetup");

export const DistributionAccountDiscount = createActionTypeModel('DistributionAccountDiscount');

export const DistributionAccountManualMatch = createActionTypeModel('DistributionAccountManualMatch');

export const DISTRIBUTION_ACCOUNT_SET_MULTIPLE_STATEMENTS_INVOICE = 'DISTRIBUTION_ACCOUNT_SET_MULTIPLE_STATEMENTS_INVOICE'
export const DISTRIBUTION_ACCOUNT_SET_STATEMENTS_INVOICE = 'DISTRIBUTION_ACCOUNT_SET_STATEMENTS_INVOICE'

export const SET_DISTRIBUTION_ACCOUNT_FILES = 'SET_DISTRIBUTION_ACCOUNT_FILES'
